// Dashboard.js

import React, { useContext, useEffect, useState } from "react";
import AlarmList from "./AlarmList";
import VideoPanel from "./VideoPanel";
import StreamComponent from "./StreamWebCam";
import AppContext from "../AppContext";
const cameras = [
  {
    id: 1,
    name: "CAM 1",
    videoSource: "video1.mp4",
    trackingParameters: [
      { label: "PHONE USAGE", progress: 50 },
      { label: "ANIMAL ACCESS", progress: 75 },
      { label: "NO SAFETY HELMET", progress: 30 },
    ],
  },
  {
    id: 2,
    name: "CAM 2",
    videoSource: "video6.mp4",
    trackingParameters: [
      { label: "PHONE USAGE", progress: 50 },
      { label: "ANIMAL ACCESS", progress: 75 },
      { label: "NO SAFETY HELMET", progress: 30 },
    ],
  },
  {
    id: 3,
    name: "CAM 3",
    videoSource: "video4.mp4",
    trackingParameters: [
      { label: "PHONE USAGE", progress: 50 },
      { label: "ANIMAL ACCESS", progress: 75 },
      { label: "NO SAFETY HELMET", progress: 30 },
    ],
  },
  {
    id: 4,
    name: "CAM 4",
    videoSource: "video7.mp4",
    trackingParameters: [
      { label: "PHONE USAGE", progress: 50 },
      { label: "ANIMAL ACCESS", progress: 75 },
      { label: "NO SAFETY HELMET", progress: 30 },
    ],
  },
];

function Dashboard() {
  const [open, setOpen] = useState(true);
  const [selectedAlarm, selectAlarm] = useState();
  const [alarms, setAlarms] = useState([
    {
      time: "2025-04-25T15:10:00.000Z",
      imageUrl: "videos/cam3.png",
      status: "critical",
      name: "No Safety Vest",
      camId: "CAM3",
    },
    {
      time: "2025-04-25T14:55:00.000Z",
      imageUrl: "videos/cam2.png",
      status: "critical",
      name: "Fire Detected",
      camId: "CAM2",
    },
    {
      time: "2025-04-25T14:50:00.000Z",
      imageUrl: "videos/cam4.png",
      status: "critical",
      name: "Fire Detected",
      camId: "CAM4",
    },
  ]);
  const [isCamera, setCamera] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isCam, setIsCam] = useState(false);
  const [video, setSelectedVideo] = useState();
  const authCtx = useContext(AppContext);
  const handleVideoDoubleClick = (video) => {
    setSelectedVideo(video);
    setCamera(true);
  };
  useEffect(() => {
    console.log(selectedAlarm, "selectedAlrm");
    setIsPlaying(true);
  }, [selectedAlarm]);
  return (
    <div className="flex py-4 justify-center items-start pr-10 pl-0 gap-4 text-white">
      {open ? (
        <div className="flex flex-col self-start max-w-80  w-1/2 md:w-full flex-grow-0">
          <AlarmList
            setAlarms={setAlarms}
            selectAlarm={selectAlarm}
            setOpen={setOpen}
            open={open}
            alarms={alarms}
          />
        </div>
      ) : (
        <div className="flex h-screen  pt-10 self-start flex-col gap-5 items-center bg-gradient-to-r from-red-800 to-orange-600 rounded-lg w-10 ml-2 mr-3 duration-500 ease-in-out">
          <div className="flex items-center relative ">
            <button type="button" onClick={() => setOpen(!open)}>
              <img
                src="Union.svg"
                alt="union"
                className=" text-orange-300 rotate-180"
              />
            </button>
          </div>
          <div>
            <div className="flex bg-red-600 rounded-full h-8 w-8 justify-center items-center">
              <div className="bg-red-500 w-5 h-5 rounded-full text-gray-300 font-semibold text-xs text-center pt-1 flex justify-center items-center">
                10
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <label className="font-semibold text-sm text-gray-300 -rotate-90">
              Alarms
            </label>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 gap-8 ">
        {authCtx.showStream ? (
          <StreamComponent />
        ) : (
          <div className=" relative ">
            <div className=" absolute p-1 top-10 left-4 rounded-md hover:bg-opacity-75 z-10 cursor-pointer bg-white bg-opacity-55">
              <img
                src="expandIcon.svg"
                className="w-6"
                onClick={() => handleVideoDoubleClick(cameras[0])}
                alt="collapse"
              />
            </div>
            <VideoPanel camera={cameras[0]} isPlaying={true} />
          </div>
        )}
        {cameras.slice(1).map((camera, index) => (
          <div key={index} className=" relative ">
            <div className=" absolute p-1 top-10 left-4 rounded-md hover:bg-opacity-75 z-10 cursor-pointer bg-white bg-opacity-55">
              <img
                src="expandIcon.svg"
                className="w-6"
                onClick={() => handleVideoDoubleClick(camera)}
                alt="collapse"
              />
            </div>
            <VideoPanel camera={camera} isPlaying={isPlaying} />
          </div>
        ))}
      </div>
      {isCamera && (
        <div className="fixed top-0 backdrop-blur z-20 overflow-hidden bg-opacity-30 h-full flex justify-center items-center w-full bg-slate-500 ">
          <div className="relative w-[80vw]">
            <div className=" absolute top-10 left-6 rounded-md hover:bg-opacity-75 z-30 cursor-pointer bg-white bg-opacity-55">
              <img
                src="collapseIcon.svg"
                className="w-8 "
                onClick={() => {
                  setCamera(false);
                  setIsCam(false);
                }}
                alt="collapse"
              />
            </div>
            <VideoPanel camera={video} isPlaying={true} />
          </div>
        </div>
      )}
      {selectedAlarm && (
        <div className="space-x-6 top-0 fixed backdrop-blur z-20 overflow-hidden bg-opacity-30 h-full flex justify-center items-center w-full bg-slate-500 ">
          <div className="relative w-[60vw]">
            <div className=" absolute top-10 left-6 rounded-md hover:bg-opacity-75 z-50 cursor-pointer bg-white bg-opacity-55">
              <img
                src="collapseIcon.svg"
                className="w-8 "
                onClick={() => {
                  selectAlarm();
                }}
                alt="collapse"
              />
            </div>
            <img width={1024} src={selectedAlarm?.imageUrl} alt={`Alarm`} />
          </div>
          <div className="grid grid-cols-1 gap-4">
            {selectedAlarm?.moreImages &&
              selectedAlarm.moreImages?.map((item, index) => (
                <div className="roundel-xl bg-red-600 p-[2px] " key={index}>
                  <img
                    className="h-14 w-14 rounded"
                    src={"data:image/jpeg;base64," + item}
                    alt=""
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
